import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/course/[slug]/[id]/IdiomDetailClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileMenuButton"] */ "/vercel/path0/components/ui/mobile-menu-button.tsx");
